import { TertiaryButton } from 'gridosComponents/Buttons';
import CloseIcon from '@mui/icons-material/Close';
import MuiDialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';

const Dialog = ({
  title,
  cancelButtonLabel,
  action,
  open,
  onClose,
  children,
  maxWidth,
  form,
  disableEscapeKeyDown,
  ...props
}) => {
  const handleClose = (event, reason) => {
    if (disableEscapeKeyDown && reason === 'escapeKeyDown') {
      return;
    }
    onClose?.(event, reason);
  };

  return (
    <MuiDialog open={open} maxWidth={maxWidth || 'sm'} fullWidth={!maxWidth} onClose={handleClose} {...props}>
      <DialogTitle>{title}</DialogTitle>
      <IconButton
        aria-label="close"
        onClick={onClose}
        sx={theme => ({
          position: 'absolute',
          right: 8,
          top: 8,
          color: theme.palette.icons.default,
        })}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent>{children}</DialogContent>
      {!form && (
        <DialogActions>
          <TertiaryButton onClick={onClose}>{cancelButtonLabel}</TertiaryButton>
          {action}
        </DialogActions>
      )}
    </MuiDialog>
  );
};

export default Dialog;
